export function shouldWaitForOnboardingSuccessWorkspace(params: {
    hasSuccessParam: boolean;
    requestedWorkspaceId?: string | null;
    currentWorkspaceId?: string | null;
}): boolean {
    if (!params.hasSuccessParam) {
        return false;
    }

    const requestedWorkspaceId = params.requestedWorkspaceId?.trim();
    if (!requestedWorkspaceId) {
        return false;
    }

    return requestedWorkspaceId !== params.currentWorkspaceId?.trim();
}
